import loadable from '@loadable/component'

export const providersLogoModule = {
  variations: {
    default: loadable(() => import('@uswitch/ev-components/lib/components/modules/providers-logo-module'))
  },
  wrapperConfig: { useContainer: true },
  hydrate: false
}
